'use strict';

(function (w, d) {
    var timeout = 300; // Tiempo para cerrar los menús (en ms)
    var isOpenClass = 'is-open';
    var hasOverlayClass = 'has-menu-overlay';
    var isMobile = false;

    var HeaderNav = w.HeaderNav = {};
    var ToggleMenu = w.ToggleMenu = {};

    HeaderNav.init = function () {
        var nav = d.querySelector('[data-headernav]');
        if (!nav) return;

        var items = nav.querySelectorAll('.menu-item-has-children');

        items.forEach(function (item) {
            item.addEventListener('mouseenter', function () {
                if (isMobile) return;
                openMenu(this);
            });

            item.addEventListener('mouseleave', function () {
                if (isMobile) return;
                setTimeout(() => closeMenu(this), timeout);
            });
        });
    };

    function openMenu(menuItem) {
        menuItem.classList.add(isOpenClass);
        d.body.classList.add(hasOverlayClass);
    }

    function closeMenu(menuItem) {
        if (!menuItem.matches(':hover') && !menuItem.querySelector(':hover')) {
            menuItem.classList.remove(isOpenClass);
        }
    }

    ToggleMenu.init = function () {
        var menu = d.querySelector('.main-nav');
        var toggleButton = d.querySelector('.menu-toggle');

        if (toggleButton) {
            toggleButton.addEventListener('click', function () {
                this.classList.toggle(isOpenClass);
                menu.classList.toggle(isOpenClass);
                d.body.classList.toggle(hasOverlayClass);
            });
        }
    };

    d.addEventListener('DOMContentLoaded', HeaderNav.init);
    d.addEventListener('DOMContentLoaded', ToggleMenu.init);

})(window, document);
